import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CircularLoader from "@/components/atoms/CircularLoader";
import ErrorMessage from "@/components/atoms/ErrorMessage";
import { ReactComponent as ValidDocumentIcon } from "@/assets/images/valid_document.svg";
import { Title } from "@/components/atoms/Typography/styles";
import Header from "@/components/molecules/Header";
import IFrameOcr from "@/components/organisms/IFrameOcr";
import { getOcrProvider } from "@/services/api";
import i18n from "@/translate/i18n";
import { LayoutWrapper } from "@/components/molecules/Wrappers/LayoutWrapper";

function OcrValidation() {
  const { kycLevel, customerId, token: apiToken } = useParams();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [ocrProviderSlug, setOcrProviderSlug] = useState("");

  useEffect(() => {
    const getProvider = async () => {
      try {
        setIsFetching(true);
        const params = {
          customer_id: customerId,
          token: apiToken,
        };
        const res = await getOcrProvider(params);
        setOcrProviderSlug(res.data.slug);
      } catch (err) {
        const message = err?.response?.data?.message;
        setError(i18n.t([`error.${message}`, "error.unspecific"]));
      } finally {
        setIsFetching(false);
      }
    };

    getProvider();
  }, [apiToken, customerId, kycLevel]);

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header />
        <LayoutWrapper>
          {isFetching ? (
            <CircularLoader />
          ) : error ? (
            <ErrorMessage>{error}</ErrorMessage>
          ) : showSuccessMessage ? (
            <div>
              <div className="flex flex-col items-center">
                <ValidDocumentIcon className="w-14 mt-8" />
              </div>
              <div className="mt-8">
                <Title>{i18n.t("idValidation.successMessage")}</Title>
              </div>
            </div>
          ) : (
            <IFrameOcr
              setError={setError}
              ocrProviderSlug={ocrProviderSlug}
              setShowSuccessMessage={setShowSuccessMessage}
            />
          )}
        </LayoutWrapper>
      </div>
    </div>
  );
}

export default OcrValidation;
